"use client";

import React from "react";
import { Dialog, DialogContent } from "@/shadcn-components/ui/dialog";
import DslExplorerPanel from "./DslExplorerPanel";

interface DslExplorerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Full-screen DSL Explorer. All internals live in DslExplorerPanel — this
 * is a thin wrapper hosting the "dialog" variant. The shadcn built-in close
 * button is suppressed (it overlapped the header search); the panel header
 * renders its own in-flow ✕ instead.
 */
export default function DslExplorerDialog({
  open,
  onOpenChange,
}: DslExplorerDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideClose
        className="flex h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] max-w-none flex-col gap-0 overflow-hidden p-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DslExplorerPanel
          variant="dialog"
          onRequestClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
